import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon, RotateCcwIcon, ChevronRightIcon, ServerIcon, RefreshCcwIcon, LinkIcon, SettingsIcon } from 'lucide-react';
import { getTenant } from '../../../theme/tokens';
import { mockBills } from '../../bills/mocks/mockBills';
export function Notifications() {
  const {
    t
  } = useTranslation("notifications");
  const navigate = useNavigate();
  const pendingBills = mockBills.filter(b => b.status === 'pending_approval');
  const recentActivity = [{
    id: 1,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 45,000 from John Doe`,
    time: '10 mins ago',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 2,
    type: 'bill',
    title: 'Bill approved',
    desc: 'INV-2026-003 by Simon Verraest',
    time: '1 hour ago',
    icon: CheckCircleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 3,
    type: 'dispute',
    title: 'New dispute opened',
    desc: `${getTenant().currency.code} 1,538.94 - Fraudulent`,
    time: '3 hours ago',
    icon: AlertTriangleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 4,
    type: 'refund',
    title: 'Refund processed',
    desc: `${getTenant().currency.code} 2,500 to Sarah Smith`,
    time: '5 hours ago',
    icon: RotateCcwIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 5,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 12,400 from Acme Corp`,
    time: 'Yesterday',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }];
  return <div data-id="element-7375">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-7376">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-7377">{t("pages.Notifications.notifications")}</h1>
        <button onClick={() => navigate('/settings')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-7378">
          
          <SettingsIcon size={14} data-id="element-7379" />
          {t("pages.Notifications.manage_preferences")}
        </button>
      </div>

      {/* Notification Center */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-7380">
        {/* Section: Urgent */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200" data-id="element-7381">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-7382">
            <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-7383"></span>
            {t("pages.Notifications.urgent_requires_immediate_action")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7384">
          <button onClick={() => navigate('/disputes/1')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7385">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7386">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-7387" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-7388">
              <p className="text-sm font-medium text-gray-900" data-id="element-7389">
                {t("pages.Notifications.dispute_dp20240001_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7390">
                {t("pages.Notifications.usd_10001_fraudulent_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-7391">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-7392">
                {t("pages.Notifications.due_in_2h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7393" />
            
          </button>
          <button onClick={() => navigate('/disputes/91')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7394">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7395">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-7396" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-7397">
              <p className="text-sm font-medium text-gray-900" data-id="element-7398">
                {t("pages.Notifications.dispute_dp20240091_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7399">
                {t("pages.Notifications.usd_153894_duplicate_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-7400">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-7401">
                {t("pages.Notifications.due_in_5h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7402" />
            
          </button>
        </div>

        {/* Section: Bills */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7403">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-7404">
            <span className="w-2 h-2 rounded-full bg-[#FF4500]" data-id="element-7405"></span>
            {t("pages.Notifications.bills_pending_approval")} {pendingBills.length} {t("pages.Notifications.items")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7406">
          {pendingBills.slice(0, 4).map(bill => <button key={bill.id} onClick={() => navigate(`/bill-detail/${bill.id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7407">
            
              <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7408">
                <FileTextIcon size={16} className="text-gray-600" data-id="element-7409" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-7410">
                <p className="text-sm font-medium text-gray-900" data-id="element-7411">
                  {bill.supplierName}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-7412">
                  {bill.billNumber} {t("pages.Notifications.due")}{' '}
                  {new Date(bill.dueDate).toLocaleDateString('en-GB')}
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-7413">
                <p className="text-sm font-semibold text-gray-900" data-id="element-7414">
                  {bill.currency} {bill.amount.toLocaleString()}
                </p>
              </div>
              <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7415" />
            
            </button>)}
          {pendingBills.length > 4 && <button onClick={() => navigate('/bills')} className="w-full px-5 py-3 text-sm font-medium text-[#FF4500] hover:bg-gray-50 transition-colors text-center" data-id="element-7416">
            
              {t("pages.Notifications.view_all")} {pendingBills.length} {t("pages.Notifications.pending_bills")}
            </button>}
        </div>

        {/* Section: Recent Activity */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7417">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-7418">
            {t("pages.Notifications.recent_activity")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7419">
          {recentActivity.map(activity => <div key={activity.id} className="flex items-center gap-4 px-5 py-4" data-id="element-7420">
            
              <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`} data-id="element-7421">
              
                <activity.icon size={16} data-id="element-7422" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-7423">
                <p className="text-sm font-medium text-gray-900" data-id="element-7424">
                  {activity.title}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-7425">{activity.desc}</p>
              </div>
              <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-7426">
                {activity.time}
              </span>
            </div>)}
        </div>

        {/* Section: System */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7427">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-7428">
            {t("pages.Notifications.system_status")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7429">
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7430">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7431">
              <ServerIcon size={16} className="text-gray-600" data-id="element-7432" />
            </div>
            <div className="flex-1" data-id="element-7433">
              <p className="text-sm font-medium text-gray-900" data-id="element-7434">{t("pages.Notifications.api_uptime")}</p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7435">
                {t("pages.Notifications.all_systems_operational")}
              </p>
            </div>
            <span className="text-sm font-bold text-green-600" data-id="element-7436">99.99%</span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7437">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7438">
              <RefreshCcwIcon size={16} className="text-gray-600" data-id="element-7439" />
            </div>
            <div className="flex-1" data-id="element-7440">
              <p className="text-sm font-medium text-gray-900" data-id="element-7441">
                {t("pages.Notifications.last_settlement")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7442">
                {t("pages.Notifications.completed_successfully")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-7443">
              {t("pages.Notifications.0130_am")}
            </span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7444">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7445">
              <LinkIcon size={16} className="text-gray-600" data-id="element-7446" />
            </div>
            <div className="flex-1" data-id="element-7447">
              <p className="text-sm font-medium text-gray-900" data-id="element-7448">
                {t("pages.Notifications.active_payment_links")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7449">
                {t("pages.Notifications.currently_receiving_traffic")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-7450">142</span>
          </div>
        </div>
      </div>
    </div>;
}